import {
    FETCH_SCHEMES_PLAN_REQUEST,
    FETCH_SCHEMES_PLAN_SUCCESS,
    FETCH_SCHEMES_PLAN_FAILURE,
  } from "./FetchMedSchemePlanTypes";
  import api from "../../utils/Api";
  
  export const fetchSchemesPlanRequest = () => {
    return {
      type: FETCH_SCHEMES_PLAN_REQUEST,
    };
  };
  
  export const fetchSchemesPlanSuccess = (schemes) => {
    return {
      type: FETCH_SCHEMES_PLAN_SUCCESS,
      payload: schemes,
    };
  };
  
  export const fetchSchemesPlanFailure = (error) => {
    return {
      type: FETCH_SCHEMES_PLAN_FAILURE,
      payload: error,
    };
  };
  
  export const fetchMedSchemesPlan = (scheme_code) => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    return async (dispatch) => {
      dispatch(fetchSchemesPlanRequest);
      try {
        const response = await api.get(
          "relatedparty/schemes/plan/autocomplete?scheme_code=" + scheme_code,
          {
            headers: headers,
          }
        );
  
        const schemesPlan = response.data.data;
        //console.log("******* patient autocomplete - ", patient);
        dispatch(fetchSchemesPlanSuccess(schemesPlan));
      } catch (error) {
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchSchemesPlanFailure(errorMsg));
      }
    };
  };
  